<div class="col-12"> 
  <router-outlet />
</div>
